var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticStyle:{"height":"100%"}},[_c('el-aside',{staticStyle:{"border-right":"1px solid #eceef3"},attrs:{"width":"270px"}},[_c('LeftMenu')],1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }